import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleEditModal, toggleNeedRefresh } from '../../store/sportsTabSlice';
import Modal from '../../components/components/modal/modal';
import ApiService from '../../components/api_services/apiService';

function EditSportModal() {
  const dispatch = useDispatch();
  const isModalOpen = useSelector((state) => state.sports.editModalOpen);
  const editedSport = useSelector((state) => state.sports.editedSport);
  const needRefresh = useSelector((state) => state.sports.needRefresh);

  const [formData, setFormData] = useState({
    name: '',
    englishName: '',
    thumbnail: '',
    active: false,
    order: 0,
  });

  const fetchSportData = async () => {
    if (!editedSport || !editedSport.id) return; // Sprawdzenie, czy editedSport istnieje
    const response = await ApiService.getSportById(editedSport.id);
    setFormData((prev) => ({
      ...prev,
      id: response.id || '',      
      name: response.name || '',
      englishName: response.nameEng || '',
      thumbnail: response.iconUrl || '',
      active: response.isActive || false,
      order: response.orderNumber || 0,
    }));    
  };

  const handleCloseModal = () => {
    dispatch(toggleEditModal());
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prev) => ({
          ...prev,
          thumbnail: file, // Przechowuj obiekt File
          thumbnailPreview: reader.result, // Przechowuj Base64 do podglądu
        }));
      };
      reader.readAsDataURL(file); // Konwertuj plik na Base64 dla podglądu
    }
  };

  const handleMoveUp = async () => {
    try {
      await ApiService.moveSportUp(formData.order);
      console.log('Przesunięto w górę:', formData.order);
      dispatch(toggleNeedRefresh()); // Wymuszenie odświeżenia
    } catch (error) {
      console.error('Błąd podczas przesuwania w górę:', error);
    }
  };

  const handleMoveDown = async () => {
    try {
      await ApiService.moveSportDown(formData.order);
      console.log('Przesunięto w dół:', formData.order);
      dispatch(toggleNeedRefresh()); // Wymuszenie odświeżenia
    } catch (error) {
      console.error('Błąd podczas przesuwania w dół:', error);
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  console.log('Dane formularza przed wysłaniem:', formData);

  let imageResponse = null;
  // Sprawdzenie, czy użytkownik załadował nowy plik graficzny

  try {
    const file = formData.thumbnail; // Obiekt File
    if (file instanceof File) {
      imageResponse = await ApiService.uploadImage(file);
      console.log('URL przesłanego obrazu:', imageResponse); // To będzie czysty tekst
    }
  } catch (error) {
    console.error('Błąd podczas przesyłania obrazu:', error);
  }


  try {
    // Tworzenie danych do wysłania
    const sportData = {
      id: editedSport.id,
      name: formData.name,
      nameEng: formData.englishName,
      ...(imageResponse && { iconId: imageResponse }), // Przypisanie URL miniatury
    };
    console.log('Dane do wysłania:', sportData);

    // Wyślij dane do API
    const response = await ApiService.updateSport(sportData);
    console.log('Odpowiedź z API:', response);    
    
  } catch (error) {
    console.error('Błąd podczas zapisywania danych:', error);
    alert('Nie udało się zapisać danych. Spróbuj ponownie.');
  }
  dispatch(toggleNeedRefresh(true));
  dispatch(toggleEditModal());
};

  const handleToggleActive = async () => {
    try {
      await ApiService.toggleSportActive(editedSport.id);            
      dispatch(toggleNeedRefresh()); // Wymuszenie odświeżenia
    } catch (error) {
      console.error('Błąd podczas zmiany statusu aktywności:', error);
    }
  };

  useEffect(() => {
    if (editedSport) {
      fetchSportData();
    }
  }, [editedSport, needRefresh]); 

  return (
    <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
      <h2>Edytuj dyscyplinę</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="name">Nazwa dyscypliny</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <label htmlFor="englishName">Nazwa w języku angielskim</label>
          <input
            type="text"
            id="englishName"
            name="englishName"
            value={formData.englishName}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <label htmlFor="thumbnail">Miniatura</label>
          <input
            type="file"
            id="thumbnail"
            name="thumbnail"
            accept="image/*"
            onChange={handleFileChange}
          />
          {formData.thumbnailPreview && (
            <div className="modal-image-preview">
              <img
                src={formData.thumbnailPreview}
                alt="Podgląd miniatury"
                className="modal-image-preview-img"
              />
            </div>
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
          {/* Kolejność */}
          <div>
            <label>Kolejność</label>
              <div className="flex-content">{formData.order}</div>
            
          </div>
          {/* Aktywność */}
          <div>
            <label>Aktywność</label>
            <div>{formData.active ? 'Aktywny' : 'Nieaktywny'}</div>
          </div>
        </div>
        <div className="modal-margin-top-20 flex-space-between">
        <button
            className='buttons-modal buttons-modal-appearance-almost-white'
            type="button"
            onClick={handleMoveUp}>
            Przenieś wyżej
          </button>
          <button
            className='buttons-modal buttons-modal-appearance-almost-white' 
            type="button"
            onClick={handleToggleActive}>
                {formData.active ? 'Dezaktywuj' : 'Aktywuj'}
            </button>    
          <button
            className='buttons-modal buttons-modal-appearance-almost-white'
            type="button"
            onClick={handleMoveDown}>
            Przenieś niżej
          </button>  
        </div>
        <div>
          <button
              className='buttons-modal buttons-modal-appearance-almost-white'
              type="button"
              onClick={handleCloseModal}>
              Anuluj
            </button>
            <button
              className='buttons-modal'
              type="submit">
                Zapisz
            </button>
          </div>
      </form>
    </Modal>
  );
}

export default EditSportModal;